import { render, staticRenderFns } from "./TeamsSettings.vue?vue&type=template&id=3dfaf0d8&"
import script from "./TeamsSettings.vue?vue&type=script&lang=js&"
export * from "./TeamsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports